import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState = {
  offers: {},
};

const offersData = createSlice({
  name: 'offers',
  initialState,
  reducers: {
    createOfferStorageName: (state, action) => {
      state.offers = {
        ...state.offers,
        [action.payload]: { data: [], loading: true, loadingNewData: false, error: '' },
      };
    },
    loadNewOffer: (state, action) => {
      state.offers[action.payload].loadingNewData = true;
    },
    setOffers: (state, action) => {
      const [key] = Object.keys(action.payload);
      const [value] = Object.values(action.payload);
      state.offers[key].loading = false;
      state.offers[key].loadingNewData = false;
      state.offers[key].data = value;
    },

    setOffersLoading: (state, action) => {
      state.offers[action.payload].loading = false;
      state.offers[action.payload].loadingNewData = false;
    },
  },
});

export const { setOffers, setOffersLoading, createOfferStorageName, loadNewOffer } = offersData.actions;

// Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default offersData.reducer;
